import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useEventContext } from "../../context/EventContext";
import { useUserContext } from "../../context/UserContext";
import { useModalContext } from "../../context/ModalContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { useApplicationContext } from "../../context/ApplicationContext";
import { useShopContext } from "../../context/ShopContext";
import UserAuthenticationModal from "../User/UserAuthenticationModal";
import CButton from "../UI/CButton";
import { ComdiLogo } from "../Icons/IconPackage/ComdiLogo";
import MenuIcons from "../Icons/IconPackage/MenuIcons";
import PopUp from "../PopUp";
import { UserMenuIcon } from "./HeaderUserMenu";
import MenuModal from "./MenuModal";
import Icons from "../Icons";
import UserBalanceHistoryModal from "./UserBalanceHistoryModal";

import "./style.scss";

export default ({ defaultPagePath }) => {
    const { event, watchKey, eventHasAuth } = useEventContext();
    const { user } = useUserContext();
    const { userBalance } = useShopContext();
    const { filteredPages, mainMenu } = useApplicationContext();
    const $locale = useLocaleContext();
    const { renderModal } = useModalContext();
    const [isShowModal, setIsShowModal] = useState(false);

    const onToggleModal = () => {
        setIsShowModal(status => !status);
    }

    const classNameMobileMenu = 'page-mobile-menu';

    return (
        <>
            <header className={'page-header'} id="page-header">
                <div className={"brand-logo" + (!event.moduleTheme.logo ? ' brand-logo--default' : '')}>
                    <NavLink to={defaultPagePath}>
                        {!!event.moduleTheme.logo && <img src={event.moduleTheme.logo} alt="" />}
                        {(!event.moduleTheme.logo && event.moduleBranding.showComdiBanner) && 
                            <ComdiLogo height={42} />
                        }
                    </NavLink>
                </div>
                <div className={`page-header-navigation`}>
                    {filteredPages.length > 1 &&
                        <nav>
                            {filteredPages.map((page) => (
                                <div key={page.path}>
                                    <NavLink to={`/event/${watchKey}/${page.path}`}>
                                        {$locale.getProperty(page, 'title')}
                                    </NavLink>
                                </div>
                            ))}
                        </nav>
                    }
                </div>
                <div className="header-buttons">
                    {
                        event?.moduleEpisode?.episodeFavorite && (
                            <NavLink
                                className={"header-bookmark"}
                                to={`/event/${watchKey}/program?tab-active=favorites`}
                            >
                                <Icons name="bookmark" />
                            </NavLink>
                        )
                    }
                    {
                        event?.moduleShop?.enabled && (
                            <a className="header-user-points"
                                onClick={() => userBalance !== null ?
                                    renderModal(UserBalanceHistoryModal, { event, $locale, userBalance, lockPageScroll: false }) :
                                    renderModal(UserAuthenticationModal, { event, $locale, lockPageScroll: false })}
                            >
                                <Icons name="user_points" />
                                {userBalance !== null && <span className="user-balance">{userBalance > 9999 ? '10K+' : userBalance.toLocaleString('ru-RU')}</span>}
                            </a>
                        )
                    }
                    {eventHasAuth && 
                        (!!user
                            ? <UserMenuIcon />
                            : <CButton
                                icon="user"
                                className="header-auth-button"
                                onClick={() => renderModal(UserAuthenticationModal, { event, $locale, lockPageScroll: false })}
                            />
                        )
                    }
                </div>
            </header>

            <div className={classNameMobileMenu} id="page-mobile-menu">
                {mainMenu.length > 1 &&
                    <div className={`${classNameMobileMenu}-navigation`}>
                        <nav>
                            {mainMenu.map((page) => (
                                <div key={page.path}>
                                    <NavLink to={`/event/${watchKey}/${page.path}`}>
                                        <MenuIcons type={page.type} />
                                        <span>{$locale.getProperty(page, 'title')}</span>
                                    </NavLink>
                                </div>
                            ))}
                            <div key={"more"}>
                                <a onClick={onToggleModal} className={`${isShowModal ? 'active' : ''}`}>
                                    <MenuIcons type="more" />
                                    {$locale.get('menu.more')}
                                </a>
                            </div>
                        </nav>
                    </div>
                }
            </div>

            <PopUp
                isOpen={isShowModal}
                onClose={onToggleModal}
            >
                <MenuModal pages={filteredPages} onClose={onToggleModal} watchKey={watchKey} />
            </PopUp>
        </>
    );
}
